import React, { useEffect, useState } from "react";

export default function LocationIndicator({ size = 0.75 }) {
  const [isActive, setIsActive] = useState(false);
  const [status, setStatus] = useState("unknown");

  useEffect(() => {
    let mounted = true;
    const check = async () => {
      if (typeof navigator === "undefined") return;
      if (!navigator.geolocation) {
        if (mounted) {
          setIsActive(false);
          setStatus("unsupported");
        }
        return;
      }

      if (navigator.permissions && navigator.permissions.query) {
        try {
          const p = await navigator.permissions.query({ name: "geolocation" });
          if (!mounted) return;
          const update = () => {
            const active = p.state === "granted";
            setIsActive(active);
            setStatus(p.state || "unknown");
          };
          update();
          p.onchange = () => mounted && update();
        } catch (err) {
          // If permissions API fails, fallback to presence check
          if (mounted) {
            setIsActive(!!navigator.geolocation);
            setStatus("unknown");
          }
        }
      } else {
        // Permissions API not available — assume geolocation present but not necessarily allowed
        if (mounted) {
          setIsActive(false);
          setStatus("prompt");
        }
      }
    };

    check();
    return () => {
      mounted = false;
    };
  }, []);

  const colorClass = isActive ? "bg-green-400 animate-pulse" : "bg-gray-400";
  // Use professional GPS status labels
  const label = isActive
    ? "GPS Active"
    : status === "unsupported"
    ? "GPS Unsupported"
    : "GPS Unavailable";

  return (
    <div className="flex items-center gap-2" aria-live="polite">
      <span
        className={`${colorClass} rounded-full border-2 border-white shadow-sm`}
        style={{ height: `${size}rem`, width: `${size}rem` }}
        title={label}
        aria-hidden="true"
      />
      <span className="text-sm text-white/90">{label}</span>
    </div>
  );
}
